// olap-client/src/utils/notifications.js

let audioContext = null;
let originalTitle = document.title;
let isSoundEnabled = true;
let isNotificationEnabled = true;

// Инициализация AudioContext (нужно после первого клика пользователя)
export const initAudio = () => {
  if (!audioContext) {
    try {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
      console.log('🔊 AudioContext initialized');
    } catch (e) {
      console.warn('AudioContext not supported:', e);
    }
  }
};

// Генерация короткого звука уведомления
export const playSound = () => {
  if (!isSoundEnabled) return;
  
  try {
    initAudio();
    if (!audioContext) return;
    
    // Создаем осциллятор для генерации звука
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // Настройки звука (короткий "бинг")
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(800, audioContext.currentTime); // Частота 800 Hz
    oscillator.frequency.exponentialRampToValueAtTime(400, audioContext.currentTime + 0.1); // Понижение до 400 Hz
    
    // Громкость
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
    
    // Запуск и остановка
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.2);
    
    console.log('🔊 Sound played');
  } catch (e) {
    console.warn('Ошибка воспроизведения звука:', e);
  }
};

// Запрос разрешения на уведомления
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.warn('Браузер не поддерживает уведомления');
    return false;
  }
  
  if (Notification.permission === 'granted') {
    return true;
  }
  
  if (Notification.permission === 'denied') {
    console.warn('Пользователь заблокировал уведомления');
    return false;
  }
  
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

// Показ браузерного уведомления
export const showNotification = (title, body, icon = '/logo192.png') => {
  if (!isNotificationEnabled) return;
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  
  // Не показываем, если вкладка активна
  if (document.visibilityState === 'visible') return;
  
  const notification = new Notification(title, {
    body,
    icon,
    badge: '/logo192.png',
    tag: 'chat-notification',
    requireInteraction: false
  });
  
  // Клик по уведомлению открывает вкладку
  notification.onclick = () => {
    window.focus();
    notification.close();
  };
  
  // Автозакрытие через 5 секунд
  setTimeout(() => notification.close(), 5000);
};

// Обновление заголовка вкладки
export const updateDocumentTitle = (unreadCount) => {
  if (unreadCount > 0) {
    document.title = `(${unreadCount}) ${originalTitle}`;
  } else {
    document.title = originalTitle;
  }
};

// Восстановление заголовка при открытии вкладки
const handleVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    // Заголовок будет восстановлен, когда все сообщения прочитаны
  }
};

document.addEventListener('visibilitychange', handleVisibilityChange);

// Настройки
export const setSoundEnabled = (enabled) => {
  isSoundEnabled = enabled;
  localStorage.setItem('chat_sound_enabled', enabled);
};

export const setNotificationEnabled = (enabled) => {
  isNotificationEnabled = enabled;
  localStorage.setItem('chat_notification_enabled', enabled);
};

// Загрузка настроек
const loadSettings = () => {
  const soundEnabled = localStorage.getItem('chat_sound_enabled');
  if (soundEnabled !== null) {
    isSoundEnabled = soundEnabled === 'true';
  }
  
  const notificationEnabled = localStorage.getItem('chat_notification_enabled');
  if (notificationEnabled !== null) {
    isNotificationEnabled = notificationEnabled === 'true';
  }
};

loadSettings();